import { isValidEmailAddress, fadeOutNotifications } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const leads = {
        isLoading: false,
        init() {
            $(document).on('click', 'a[href="{lead}"]', this, this.openModal);
            $(document).on('click', '#lead-send-btn', this, this.send);
        },
		openModal(event) {
			const _this = event.data;
			event.preventDefault();

			if (_this.isLoading) {
				console.log('is loading...');
				return false;
			}

			_this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			$.ajax({
				type: "GET",
				url: baseURL + "/leads/create",
	            //data: values,
				success: function(html) {
					_this.isLoading = false;
					$(element).find('i').hide();

					$('#leads-modal-container').html(html);

					$('#leads-modal').modal('show');
					$('#leads-modal').on('shown.bs.modal', function (e) {
						
					});

					$('#leads-modal').on('hidden.bs.modal', function() {

					});

				},
				error(error) {
					_this.isLoading = false;
					$(element).find('i').hide();
				}
			});
		},
		send(event) {
			const _this = event.data;

			if (_this.isLoading) {
				console.log('is loading...');
				return false;
			}

			var error = false;
			$('.leads-form').find('.form-control').removeClass('is-invalid');
			$('.leads-form').find('.form-check-input').removeClass('is-invalid');
			//$('#bookings-form-error-msg').hide();

			if ($('#leads_name').val() == '') {
				$('#leads_name').addClass('is-invalid');
				error = true;
			}
			if ($('#leads_email').val() == '') {
				$('#leads_email').addClass('is-invalid');
				error = true;
			}
			if ($('#leads_phone').val() == '') {
				$('#leads_phone').addClass('is-invalid');
				error = true;
			}
			if (!$('#leads_terms_and_condition').is(':checked')) {
				$('#leads_terms_and_condition').addClass('is-invalid');
				error = true;
			}
			if (error) {
				return false;
			}

			_this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values = 'page=' + document.title;
			values += '&name=' + $('#leads_name').val();
			values += '&email=' + $('#leads_email').val();
			values += '&phone=' + $('#leads_phone').val();
			values += '&_token=' + $("meta[name='csrf-token']").attr("content");
	        $.ajax({
	            type: "POST",
	            url: baseURL + "/leads/create",
	            data: values,
	            success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
						var errorHtml = '';
						for(var errorKey in response.errors) {
							if(!response.errors.hasOwnProperty(errorKey)) continue;
							for(var error in response.errors[errorKey]) {
								$("#leads_"+errorKey).addClass('is-invalid');
								errorHtml += response.errors[errorKey][error] + '<br>';
							}
						}

						// Swal.fire({
						// 	//icon: "success",
						// 	title: "Eroare!",
						// 	html: errorHtml
						// });
						return false;
					}

					if (response.status == 1) {

						$('#leads-modal').modal('hide');

						$('#leads-modal').on('hidden.bs.modal', function() {
							$('#leads-modal-container').html('');
						});

						Swal.fire({
							//icon: 'success',
							title: response.title,
							html: response.message
						});

						return;
						$('#leads-modal').on('hidden.bs.modal', function() {
							$('#leads-modal-container').html('');

							$('#leads-modal-container').html(`<div class="modal template-confirmation fade" id="leads-modal-confirmation" tabindex="-1" aria-hidden="true">
					            <div class="modal-dialog modal-dialog-centered">
					                <div class="modal-content">
					                    <div class="modal-header">
					                        <h5 class="modal-title mx-auto">${response.title}</h5>
					                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
					                            <i class="fal fa-times"></i>
					                        </button>
					                    </div>
					                    <div class="modal-body text-center">
					                        <p>${response.message}</p>
					                    </div>
					                </div>
					            </div>
					        </div>`);
							$('#leads-modal-confirmation').modal('show');
						});
						return;
					}
	            },
				error(error) {
					_this.isLoading = false;
					$(element).find('i').hide();
				}
	        });
		},
	};
    leads.init();
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/leads.js